import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridOptions } from 'ag-grid-community';
import { AG_GRID_DEFAULT_OPTIONS } from '../../../../core/config/aggrid.default.config';
import { CodigoArticuloGastoDtoOut } from '../../../models/maestros/codigoArticuloGasto.model';
import { CodigoArticuloGastoService } from '../../services/gastos-codigos-articulos.service';

@Component({
  selector: 'app-gastos-codigos-articulos',
  standalone: true,
  imports: [CommonModule, RouterModule, AgGridAngular],
  templateUrl: './gastos-codigos-articulos.component.html',
  styleUrl: './gastos-codigos-articulos.component.scss',
})
export default class CodigosArticulosGastosComponent implements OnInit {
  gastosCodigosArticulos: CodigoArticuloGastoDtoOut[] = [];

  constructor(private readonly codigoArticuloGastoService: CodigoArticuloGastoService) {}

  ngOnInit(): void {
    this.obtenerCodigosArticulos();
  }

  gridOptions: GridOptions = { ...AG_GRID_DEFAULT_OPTIONS, domLayout: 'autoHeight' };

  columnDefs: ColDef[] = [
    { field: 'proveedorNombre', headerName: 'Proveedor', resizable: false },
    { field: 'iva10', resizable: false },
    { field: 'iva21', resizable: false },
  ];

  obtenerCodigosArticulos(): void {
    this.codigoArticuloGastoService.getCodigosArticulos().subscribe({
      next: (data) => {
        this.gastosCodigosArticulos = data;
      },
      error: (err) => {
        console.error('GastosCodigosArticulosComponent - Error:', err);
      },
    });
  }
}
